export const FETCH_SCHOOL_LOGO_REQUEST = 'FETCH_SCHOOL_LOGO_REQUEST';
export const FETCH_SCHOOL_LOGO_SUCCESS = 'FETCH_SCHOOL_LOGO_SUCCESS';
export const FETCH_SCHOOL_LOGO_FAILURE = 'FETCH_SCHOOL_LOGO_FAILURE';